import state from './app.state'
import getters from './app.getters'

export default {
  namespaced: true,
  state,
  getters,
}
